import { Injectable } from '@angular/core';
import { PAGE_FIX_FIXABLE_TYPES } from '../../constants/page-fix-fixable-types';
import { PageFixModel } from '@client/app/services/api/pagefix-repo/page-fix-model';

@Injectable({
    providedIn: 'root',
})

export class PageFixListService {
    getError (pageFix: PageFixModel): string[] {
        const selectorQueries = pageFix.selector.match(/;(.*)/)?.[1] ?? '';
        const fixableType = pageFix.normalizeFixableType();
        if (PAGE_FIX_FIXABLE_TYPES.custom === fixableType || PAGE_FIX_FIXABLE_TYPES.misspelling === fixableType) {
            return [selectorQueries];
        } else if (PAGE_FIX_FIXABLE_TYPES.accessibility_check === fixableType) {
            return JSON.parse(selectorQueries);
        } else {
            return JSON.parse(selectorQueries).map(function (selector) {
                const res = selector.match(/.*="(.*)"]/);
                if (res) {
                    return res[1];
                }
                return selector;
            });
        }
    }
}
